var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisableAllMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0158 4.47403C8.75265 4.14618 8.7139 3.68008 8.99106 3.36399C9.7242 2.52788 10.8003 2 11.9997 2C14.2088 2 15.9997 3.79086 15.9997 6V11C15.9997 11.7907 15.1383 12.1021 14.6181 11.4539L9.0158 4.47403ZM17.5282 15.0796C17.9014 15.5445 18.6124 15.5431 18.913 15.0283C19.2758 14.4071 19.5572 13.7325 19.7427 13.0192C19.8815 12.4856 19.4509 12 18.8996 12C18.4499 12 18.0737 12.329 17.9463 12.7603C17.8237 13.1748 17.6591 13.5712 17.4572 13.9446C17.261 14.3075 17.2699 14.7578 17.5282 15.0796Z",
    fill: "#AC92ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9997 11C7.9997 13.4935 10.3701 15.4067 12.7896 14.922L14.2729 16.77C13.569 17.0475 12.8022 17.2 11.9997 17.2C9.18701 17.2 6.81177 15.327 6.05314 12.7603C5.92569 12.329 5.54951 12 5.09982 12C4.54847 12 4.11795 12.4856 4.25671 13.0192C5.0783 16.1786 7.78238 18.5785 11.0997 18.9499V21.1C11.0997 21.5971 11.5026 22 11.9997 22C12.4968 22 12.8997 21.5971 12.8997 21.1V18.9499C13.8002 18.8491 14.6555 18.5988 15.4403 18.2244L17.3978 20.6634C17.709 21.051 18.2754 21.113 18.6631 20.8019C19.0507 20.4907 19.1127 19.9243 18.8016 19.5366L6.60158 4.33665C6.29045 3.94902 5.72398 3.887 5.33634 4.19813C4.94871 4.50926 4.88669 5.07572 5.19782 5.46336L7.9997 8.95422V11Z",
    fill: "#AC92ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableAllMic);
export default __webpack_public_path__ + "static/media/disable_all_mic.f38ab0b58438d0df772767c830403a98.svg";
export { ForwardRef as ReactComponent };